"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var factory_1 = require("../../commerceEventCreators/factory");
var utils_1 = require("../../utils");
var commerceinteractionHander = function (event, context) {
    if (event.eventType !== analytics_layer_1.EventTypes.CommerceInteraction || context.isHandled) {
        return;
    }
    // main:
    var _a = (0, factory_1.getCreator)(event.eventName)(event), _b = _a[0], mainEventData = _b === void 0 ? null : _b, _c = _a[1], linkEventData = _c === void 0 ? null : _c, _d = _a[2], abImpressionEventData = _d === void 0 ? null : _d;
    if (!mainEventData) {
        return;
    }
    (0, utils_1.pushEvent)(mainEventData);
    // link:
    if (linkEventData) {
        (0, utils_1.pushEvent)(linkEventData);
    }
    // ab:
    if (abImpressionEventData) {
        (0, utils_1.pushEvent)(abImpressionEventData);
    }
    context.isHandled = true;
};
exports.default = commerceinteractionHander;
